import { useState, useEffect } from "react";
import "../css/countdownTimer.css";

function CountdownTimer({ Time = 60, OnComplete }) {
  const [timeRemaining, setTimeRemaining] = useState(Time);
  const [timeIsRunning, setTimeIsRunning] = useState(true);

  
  useEffect(() => {
    if (!timeIsRunning) return;

    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setTimeIsRunning(false);
          OnComplete?.();
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeIsRunning]);

  
const minutes = Math.floor(timeRemaining / 60);
const seconds = timeRemaining % 60;

const displayTime = `${minutes}:${seconds
    .toString()
    .padStart(2, "0")}`;
  const timerClass =
    timeRemaining <= 10
        ? "countdown-time danger"
        : timeRemaining <= 30
        ? "countdown-time warning"
        : "countdown-time";
  return (
    <div className="countdown-panel">
      <span className="countdown-panel-title">
        <b>Time Remaining!:</b>
      </span>

    <span className={timerClass}>
        {displayTime}
    </span>
    </div>
  );
}

export default CountdownTimer;
